<cam-card (click)="this.login()">
  <cam-card-content>
    <cam-button (action)="this.login()">{{ 'user.login' | translate }}</cam-button>
  </cam-card-content>
</cam-card>
